import { fixedTons } from "./common";

export const generateBarChartDataSet = (labels, data, colors) => {
  if (data.length !== labels.length || data.length !== colors.length) {
    throw new Error(
      "Labels, data, and colors arrays must have the same length"
    );
  }
  return labels.map((label, index) => ({
    label,
    data: data[index],
    backgroundColor: colors[index].background,
    borderColor: colors[index].border,
    borderWidth: 0.5,
  }));
};

const getColorForCategory = (categoryType, colors) => {
  const defaultColors = [
    { label: "Wastewater", color: "rgba(255, 187, 51, 0.8)" },
    { label: "Hazardous Waste", color: "rgba(0, 102, 231, 0.8)" },
    { label: "Non-Hazardous Waste", color: "rgba(0, 255, 0, 0.8)" },
    {
      label: "Construction & Demolition Waste",
      color: "rgba(255, 99, 132, 0.8)",
    },
  ];

  const colorsMap = colors || defaultColors;
  return (
    colorsMap.find((c) => c.label === categoryType)?.color ||
    "rgba(0, 0, 0, 0.1)"
  );
};

export const manipulateDataForBarChart = ({ data, colors, type }) => {
  console.log("insee", data, type);
  return (
    data &&
    data?.map((item) => {
      const color = getColorForCategory(
        type === "vendorPurchase" || type === "vendorPurchaseEmission"
          ? item?.vendor
          : type === "purchaseEmission" ||
            type === "employeeCommuteEmission" ||
            type === "purchaseEmissionData" ||
            type === "employeeCommuteTransport" ||
            type === "travelmode" ||
            type === "vendoranalysis"
          ? item._id
          : type === "waste" || type === "facility"
          ? item?.categoryType
          : type === "discharge" || type === "withdrawal"
          ? item?.source
          : type === "transportationEmission"
          ? item?.emission
          : item?.categoryType,
        colors
      );

      return {
        label:
          type === "vendorPurchase" || type === "vendorPurchaseEmission"
            ? item?.vendor
            : type === "purchaseEmission" ||
              type === "purchaseEmissionData" ||
              type === "employeeCommuteEmission" ||
              type === "employeeCommuteTransport" ||
              type === "travelmode" ||
              type === "vendoranalysis"
            ? item._id
            : type === "discharge" || type === "withdrawal"
            ? item?.source
            : type === "transportationEmission"
            ? item?.emission
            : item?.categoryType,
        data:
          type === "transportationEmission"
            ? item?.twelveMonthData.map((month) =>
                month?.totalEmission)?.filter(Boolean) 
              

            : item.data.map((month) =>
                type === "commute" ||
                type === "vendorPurchase" ||
                type === "category" ||
                type === "purchaseEmissionData"
                  ? month.totalSpent
                  : type === "vendorPurchaseEmission" ||
                    type === "employeeCommuteTransport" ||
                    type === "employeeCommuteEmission" ||
                    type === "travelmode" ||
                    type === "vendoranalysis"
                  ? fixedTons(month?.totalEmission)
                  : type === "purchaseEmission" ||
                    type === "waste" ||
                    type === "facility" ||
                    type === "discharge" ||
                    type === "withdrawal" ||
                    type === "businessTravelEmission"
                  ? month.total
                  : month.total * 1000
              ),
        backgroundColor: color,
        borderColor: color.replace("0.8", "1"),
        borderWidth: 0.5,
      };
    })
  );
};

export const generateBarChartDataSetForWaste = (data, colors, label) => {
  let combinedData = [];
  if (label === "Waste Management") {
    combinedData = data?.map((item) => item?.totalWasteManaged);
  } else if (label === "Temporal Analysis") {
    combinedData = data?.map((item) => item?.totalQuantityInTons * 1000);
  } else if (label === "Commute") {
    combinedData = data?.map((item) => item?.totalEmission);
  } else if (label === "Trips") {
    combinedData = data?.map((item) => item?.numberOfTrips);
  } else if (label === "Employee Trips") {
    combinedData = data?.map((item) => item?.numberOfEmployees);
  } else if (label === "Fuel Efficiency") {
    combinedData = data?.map((item) => item?.averageFuelEfficiency);
  } else if (label === "Vendor Emission" || label === "Vendor Spent") {
    combinedData = data?.map((item) =>item?.totalSpent);
  } else if (label === "Facility Emission") {
    combinedData = data?.map((item) => item?.totalEmission);
  } else if (label === "Facility Spent") {
    combinedData = data?.map((item) => item?.amountSpend);
  } else if (label === "Activity Spend") {
    combinedData = data?.map((item) => item?.totalSpent);
  } else if (label === "Average Distance") {
    combinedData = data?.map((item) => item?.avgDistance);
  } else if (label === "Trip Frequency") {
    combinedData = data?.map((item) => item?.total);
  } else if (label === "Days") {
    combinedData = data?.map((item) => item?.totalDays);
  } else if (label === "Position") {
    combinedData = data?.map((item) => item?.total);
  } else if (
    label === "Production Materials" ||
    label === "Finished Goods" ||
    label === "Transportation and Distribution" ||
    label === "Information Technology and Communication" ||
    label === "Professional Services" ||
    label === "Others"
  ) {
    combinedData = data?.map((item) => item?.totalSpent);
  } else if (label === "Waste Generated") {
    combinedData = data?.map((item) => item?.totalWaste);
  } else {
    combinedData = data?.map((item) => item?.totalWaste * 1000);
  }
  console.log(combinedData?.filter(Boolean),"c1",label)
  const defaultColor = colors || "rgba(0, 0, 0, 0.8)";
  return [
    {
      label: label || "Waste Generated",
      data: combinedData?.filter(Boolean),
      backgroundColor: defaultColor,
      borderColor: defaultColor.replace("0.8", "1"),
      borderWidth: 0.5,
    },
  ];
};
